import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import WhyAnalyzer from './components/WhyAnalyzer';
import './App.css';
import { SettingsProvider } from './context/SettingsContext';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#2C5282',
      light: '#4299E1',
      dark: '#1A237E'
    },
    background: {
      default: '#efefef',
      paper: '#FFFFFF'
    },
    whyGradients: [
      '#5C6BC0',
      '#3F51B5', 
      '#303F9F',
      '#283593',
      '#1A237E'
    ]
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          padding: '1px',
          borderRadius: '2px'
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          marginBottom: '16px'
        }
      }
    }
  },
  email: {
    container: {
      maxWidth: '900px',
      margin: '0 auto',
      padding: '20px',
      fontFamily: 'Arial, sans-serif'
    },
    header: {
      color: '#2C5282'
    },
    section: {
      background: '#F7FAFC',
      padding: '15px',
      borderRadius: '8px',
      marginBottom: '20px'
    }
  },
  analysis: {
    rootCause: {
      background: '#2C5282',
      color: '#FFFFFF',
      titleColor: '#FFFFFF'
    },
    whySection: {
      background: '#FFFFFF',
      color: '#2D3748',
      titleColor: '#2C5282',
      labelColor: '#2C5282'
    },
    finalSections: {
      background: '#F7FAFC',
      color: '#2D3748',
      titleColor: '#2C5282'
    }
  },
  intro: {
    container: {
      maxWidth: '900px',
      margin: '0 auto',
      marginBottom: '24px',
      backgroundColor: '#ffffff',
      padding: '24px',
      borderRadius: '8px',
      color: '#2D3748'
    },
    title: {
      fontSize: '3rem',
      fontWeight: 700,
      marginBottom: '20px'
    },
    section: {
      marginBottom: '8px'
    },
    sectionTitle: {
      fontSize: '1.5rem',
      fontWeight: 600,
      marginBottom: '8px',
      marginTop: '8px'
    },
    subheading: {
      fontSize: '1.5rem',
      fontWeight: 600,
      marginBottom: '20px',
      marginTop: '20px'
    },
    list: {
      marginBottom: '8px'
    },
    proTip: {
      fontStyle: 'italic',
      marginTop: '8px'
    }
  },
  dynamicText: {
    solution: {
      backgroundColor: '#98FFE0',
      color: '#000000',
      fontWeight: 700,
      display: 'inline-block',
      padding: '5px',
      mx: 1
    },
    whyStep: {
      backgroundColor: '#98FFE0',
      color: '#000000',
      fontWeight: 700,
      display: 'inline-block',
      padding: '5px',
      mx: 1
    }
  }
});

function App() {
  return (
      <ThemeProvider theme={theme}>
          <SettingsProvider>
              <div className="App">
                  <WhyAnalyzer />
              </div>
          </SettingsProvider>
      </ThemeProvider>
  );
}

export default App;